import { ELocalStorageKey } from '/@/types/enums'
import { CURRENT_CONFIG } from '/@/api/http/config'
import cookies from 'vue-cookies'
import { encryptPathSegment } from '/@/api/rsa/api-crypto'

export function getWebsocketUrl () {
  const token: string = cookies.get(ELocalStorageKey.Token) || '' as string
  // encryptPathSegment(encodeURI(token))
  const url = CURRENT_CONFIG.websocketURL + '?x-auth-token=' + token
  // console.log('CURRENT_CONFIG.websocketURL', CURRENT_CONFIG.websocketURL + '?x-auth-token=' + token)
  return url
}
